/**
 * NANKURE MASTER SCRIPTS (Consolidado)
 * Gestión unificada de Menú GSAP, Inyección de Iconos y Scroll Indicator.
 */

// The newsletter close icon sits on the image only in the mobile form step.
customElements.whenDefined('shopify-forms-embed').then(() => {
  function styleNewsletterClose() {
    const root = document.getElementById('app-embed-container-1169243')?.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('[data-nankure-popup-close]')) {
      const style = document.createElement('style');
      style.dataset.nankurePopupClose = '';
      style.textContent = `
        @media screen and (max-width: 768px) {
          [data-form-root][data-current-step="form"] {
            --button-close-color: #EBECEF;
          }
        }
      `;
      root.appendChild(style);
    }
    return true;
  }

  if (styleNewsletterClose()) return;
  const observer = new MutationObserver(() => {
    if (styleNewsletterClose()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
});

// --- 1. CONFIGURACIÓN DE ICONOS SVG (CARRITO Y CUENTA) ---
const NANKURE_ICONS = {
  cart: `<svg class="nankure-icon" width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_576_911)"><path d="M12.3765 13.6067H6.62102C5.34539 13.6067 4.31274 12.574 4.31274 11.2984V5.40623H19.9999V5.9833C19.9999 10.1898 16.5831 13.6067 12.3765 13.6067ZM5.4517 6.56037V11.3136C5.4517 11.9514 5.96802 12.4829 6.62102 12.4829H12.3765C15.763 12.4829 18.5421 9.88611 18.8306 6.57555H5.4517V6.56037Z" fill="currentColor"/><path d="M16.7502 20C15.8846 20 15.186 19.3014 15.186 18.4358C15.186 17.5702 15.8846 16.8717 16.7502 16.8717C17.6158 16.8717 18.3144 17.5702 18.3144 18.4358C18.3144 19.3014 17.6158 20 16.7502 20ZM16.7502 17.631C16.3098 17.631 15.9453 17.9954 15.9453 18.4358C15.9453 18.8762 16.3098 19.2407 16.7502 19.2407C17.1906 19.2407 17.5551 18.8762 17.5551 18.4358C17.5551 17.9954 17.1906 17.631 16.7502 17.631Z" fill="currentColor"/><path d="M6.07441 20C5.20881 20 4.51025 19.3014 4.51025 18.4358C4.51025 17.5702 5.20881 16.8717 6.07441 16.8717C6.94002 16.8717 7.63858 17.5702 7.63858 18.4358C7.63858 19.3014 6.94002 20 6.07441 20ZM6.07441 17.631C5.63402 17.631 5.26956 17.9954 5.26956 18.4358C5.26956 18.8762 5.63402 19.2407 6.07441 19.2407C6.51481 19.2407 6.87927 18.8762 6.87927 18.4358C6.87927 17.9954 6.51481 17.631 6.07441 17.631Z" fill="currentColor"/><path d="M18.4358 16.1276H3.56872C2.59681 16.1276 1.80714 15.3379 1.80714 14.366V1.73121C1.80714 1.4123 1.54897 1.13895 1.21488 1.13895H0V0H1.21488C2.1716 0 2.94609 0.774487 2.94609 1.73121V14.366C2.94609 14.7153 3.23462 14.9886 3.56872 14.9886H18.4358V16.1276Z" fill="currentColor"/></g><defs><clipPath id="clip0_576_911"><rect width="20" height="20" fill="currentColor"/></clipPath></defs></svg>`,
  account: `<svg class="nankure-icon" width="20" height="22" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_576_902)"><path d="M11.8806 11.4437V10.2494C13.0149 9.35752 13.7761 7.98186 13.7761 6.42479V4.83749C13.7761 2.17687 11.6269 0 9 0C6.37313 0 4.22388 2.17687 4.22388 4.83749V6.42479C4.22388 8.04233 5.01493 9.46334 6.22388 10.3401H6.1194V11.4437C2.50746 12.381 0 15.6463 0 19.4256V19.9849H18V19.4256C18 15.6311 15.4925 12.3658 11.8806 11.4286V11.4437ZM5.34328 6.42479V4.83749C5.34328 2.79667 6.98507 1.13379 9 1.13379C11.0149 1.13379 12.6567 2.79667 12.6567 4.83749V6.42479C12.6567 8.46561 11.0149 10.1285 9 10.1285C6.98507 10.1285 5.34328 8.46561 5.34328 6.42479ZM9 11.2472C9.62687 11.2472 10.2239 11.1111 10.7612 10.8995V13.2577L8.98507 15.5102L7.22388 13.2729V10.8995C7.77612 11.1262 8.37313 11.2472 8.98507 11.2472H9ZM1.13433 18.8662C1.32836 16.3114 2.86567 14.0892 5.1194 13.0159L9.74627 18.8662H1.13433ZM11.6418 18.8662L9.95522 16.7196L12.8806 13.0159C15.1343 14.0892 16.6716 16.2963 16.8806 18.8662H11.6567H11.6418Z" fill="currentColor"/><circle cx="10.5" cy="5.5" r="0.5" fill="currentColor"/><circle cx="7.5" cy="5.5" r="0.5" fill="currentColor"/></g><defs><clipPath id="clip0_576_902"><rect width="18" height="20" fill="currentColor"/></clipPath></defs></svg>`
};

// --- 1b. ETIQUETAS DEL MENÚ MÓVIL ---
// Los títulos del menú de Shopify llevan espacios intercalados ("PRO DUC TOS")
// para forzar los saltos de línea del menú desktop. En el drawer móvil se
// muestran limpias mediante esta correspondencia por URL. Si un enlace no
// aparece aquí, se conserva el título original del menú.
const NANKURE_DRAWER_LABELS = {
  '/collections/kalagua': 'PRODUCTOS',
  '/pages/universo-nankure': 'UNIVERSO NANKURE',
  '/pages/area-profesional': 'ÁREA PROFESIONAL',
  '/pages/donde-encontrarnos': 'DÓNDE ENCONTRARNOS',
  '/pages/contacto': 'CONTACTO'
};

// --- 2. MOTOR PRINCIPAL ---

function initNankureScripts() {
  if (typeof gsap === 'undefined') return;

  // A0. Etiquetas limpias en el menú móvil
  document.querySelectorAll('.menu-drawer__menu-item:not(.nankure-label-ready)').forEach(item => {
    item.classList.add('nankure-label-ready');
    const textEl = item.querySelector('.menu-drawer__menu-item-text');
    if (!textEl) return;
    const path = (item.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
    const label = NANKURE_DRAWER_LABELS[path];
    if (label) textEl.textContent = label;
  });

  // B. Inyectar Iconos Personalizados
  // const cartNative = document.querySelectorAll('#cart-icon-bubble svg, cart-drawer-component svg, .header__icon--cart svg');
  // const accountNative = document.querySelectorAll('shopify-account svg, .header__icon--account svg, .account-button__icon svg');
  
  const cartNative = document.querySelectorAll('button[data-testid="cart-drawer-trigger"] cart-icon .svg-wrapper > svg, #cart-icon-bubble > svg, .header__icon--cart > svg');
  const accountNative = document.querySelectorAll('.account-button > shopify-account span[slot="signed-out-avatar"] svg, .header__icon--account > svg, .account-button__icon > svg');


  cartNative.forEach(icon => {
    if (!icon.classList.contains('nankure-icon')) icon.outerHTML = NANKURE_ICONS.cart;
  });
  accountNative.forEach(icon => {
    if (!icon.classList.contains('nankure-icon')) icon.outerHTML = NANKURE_ICONS.account;
  });

  // C. Inicializar Scroll Indicators (hero y footer)
  // Ambos comparten el id NankureScroll, así que se seleccionan por clase:
  // getElementById solo devolvía el primero y el del footer se quedaba sin animar.
  document.querySelectorAll('.nankure-scroll-wrapper:not(.gsap-ready)').forEach(scrollWrapper => {
    const isFooter = scrollWrapper.classList.contains('nankure-scroll-footer');

    // Rescate del DOM: solo el del hero, que debe colgar de su propia section
    if (!isFooter) {
      const sectionRoot = scrollWrapper.closest('.shopify-section');
      if (sectionRoot && scrollWrapper.parentNode !== sectionRoot) {
        sectionRoot.style.position = 'relative';
        sectionRoot.appendChild(scrollWrapper);
      }
    }

    scrollWrapper.classList.add('gsap-ready');
    const sOriginal = scrollWrapper.querySelector('.scroll-text-layer.original');
    const sClone = scrollWrapper.querySelector('.scroll-text-layer.clone');
    if (sOriginal && sClone) {
      gsap.set(sClone, { yPercent: -100 });
      const sTl = gsap.timeline({ repeat: -1, defaults: { duration: 2, ease: "power2.inOut" } });
      sTl.to(sOriginal, { yPercent: 100 }, 0).to(sClone, { yPercent: 0 }, 0);
      scrollWrapper.addEventListener('mouseenter', () => sTl.pause());
      scrollWrapper.addEventListener('mouseleave', () => sTl.play());
      const sLink = scrollWrapper.querySelector('.nankure-scroll-link');
      if (sLink) {
        sLink.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({ top: isFooter ? 0 : window.innerHeight, behavior: 'smooth' });
        });
      }
    }
  });
}

// --- 3. DISPARADORES DE CARGA (HYDRATION HANDLERS) ---

document.addEventListener('DOMContentLoaded', initNankureScripts);
window.addEventListener('load', initNankureScripts);
document.addEventListener('shopify:section:load', initNankureScripts);

// Re-intentos necesarios: Shopify vuelve a renderizar el header después de la
// carga y sustituye el marcado del menú, perdiendo el texto GSAP y las
// etiquetas del drawer. Sin estos reintentos el efecto hover no llega a aplicarse.
setTimeout(initNankureScripts, 300);
setTimeout(initNankureScripts, 800);
setTimeout(initNankureScripts, 2000);

/* =========================================
   FIX MENÚ MÓVIL + MIX-BLEND
   Apaga difference solo mientras el drawer está abierto
========================================= */

function initNankureMobileDrawerFix() {
  if (window.nankureMobileDrawerFixReady) return;
  window.nankureMobileDrawerFixReady = true;

  const mobileQuery = window.matchMedia('(max-width: 989px)');

  function openDrawerState() {
    if (!mobileQuery.matches) return;
    document.body.classList.add('nankure-mobile-drawer-open');
  }

  function closeDrawerState() {
    document.body.classList.remove('nankure-mobile-drawer-open');
  }

  document.addEventListener('click', function(event) {
    const target = event.target;

    const openTrigger = target.closest(
      '.header-drawer-icon--menu, .header__icon--menu, [aria-label="Menu"], [aria-label="Open menu"], [aria-label="Abrir menú"]'
    );

    const closeTrigger = target.closest(
      '.menu-drawer__close-button, .header-drawer-icon--close, [aria-label="Close"], [aria-label="Cerrar"], [aria-label="Cerrar menú"]'
    );

    if (openTrigger) {
      setTimeout(openDrawerState, 50);
      setTimeout(openDrawerState, 250);
    }

    if (closeTrigger) {
      setTimeout(closeDrawerState, 50);
      setTimeout(closeDrawerState, 250);
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeDrawerState();
    }
  });

  mobileQuery.addEventListener('change', function() {
    if (!mobileQuery.matches) {
      closeDrawerState();
    }
  });
}

document.addEventListener('DOMContentLoaded', initNankureMobileDrawerFix);
window.addEventListener('load', initNankureMobileDrawerFix);
document.addEventListener('shopify:section:load', initNankureMobileDrawerFix);


// - - - - - DIEGO - - - - -
// ANIMACIONES - PÁGINA DE CONTACTO
/* =========================================
   NANKURE CONTACT PAGE - GSAP INTRO
========================================= */

function initNankureContactAnimation() {
  if (typeof gsap === 'undefined') return;

  const contactPage = document.querySelector('.nankure-contact-page');
  if (!contactPage || contactPage.classList.contains('contact-gsap-ready')) return;

  contactPage.classList.add('contact-gsap-ready');

  const bg = contactPage.querySelector('.nankure-contact-page__background');
  const card = contactPage.querySelector('.nankure-contact-page__card');
  const info = contactPage.querySelector('.nankure-contact-page__info');
  const social = contactPage.querySelector('.nankure-contact-page__social');
  const brand = contactPage.querySelector('.nankure-contact-page__brand');

  const tl = gsap.timeline({
    defaults: {
      ease: 'power3.out'
    }
  });

  /* Estado inicial */
  gsap.set(bg, {
    yPercent: 100,
    opacity: 1
  });

  gsap.set(card, {
    scaleY: 0,
    opacity: 1,
    transformOrigin: 'center center'
  });

  gsap.set([info, social], {
    opacity: 0,
    y: 12
  });

  gsap.set(brand, {
    opacity: 0,
    y: 90
  });

  /* Animación */
  tl.to(bg, {
    yPercent: 0,
    duration: 1.25
  })

  .to(card, {
    scaleY: 1,
    duration: 0.95,
    ease: 'power4.out'
  }, '-=0.35')

  .to([info, social], {
    opacity: 1,
    y: 0,
    duration: 0.75,
    stagger: 0.08
  }, '-=0.35')

  .to(brand, {
    opacity: 1,
    y: 0,
    duration: 0.9,
    ease: 'power3.out'
  }, '-=0.25');
}

window.addEventListener('load', () => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      initNankureContactAnimation();
    });
  });
});

document.addEventListener('shopify:section:load', () => {
  setTimeout(initNankureContactAnimation, 150);
});

/* =========================================
   NANKURE LOCATIONS - MOBILE CLICK CARDS
========================================= */

function initNankureLocationsMobile() {
  const locationsPage = document.querySelector('.nankure-locations-page');
  if (!locationsPage || locationsPage.classList.contains('locations-mobile-ready')) return;

  locationsPage.classList.add('locations-mobile-ready');

  const locations = locationsPage.querySelectorAll('.nankure-location');

  locations.forEach(location => {
    const marker = location.querySelector('.nankure-location__marker');
    const close = location.querySelector('.nankure-location__close');

    if (marker) {
      marker.addEventListener('click', event => {
        if (!window.matchMedia('(max-width: 989px)').matches) return;

        event.preventDefault();
        event.stopPropagation();

        locations.forEach(item => {
          if (item !== location) item.classList.remove('is-open');
        });

        location.classList.toggle('is-open');
      });
    }

    if (close) {
      close.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();

        location.classList.remove('is-open');
      });
    }
  });

  document.addEventListener('click', event => {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    if (event.target.closest('.nankure-location')) return;

    locations.forEach(location => {
      location.classList.remove('is-open');
    });
  });

  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 990px)').matches) {
      locations.forEach(location => {
        location.classList.remove('is-open');
      });
    }
  });
}

window.addEventListener('load', initNankureLocationsMobile);
document.addEventListener('shopify:section:load', initNankureLocationsMobile);

/* =========================================
   COLLECTION GRID FILLER REVEAL
========================================= */

function initNankureProductGridFillers() {
  const fillers = document.querySelectorAll('.nankure-product-grid-filler');

  if (!fillers.length) return;

  fillers.forEach((filler) => {
    if (filler.dataset.revealReady === 'true') return;

    filler.dataset.revealReady = 'true';

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          filler.classList.add('is-visible');
          obs.unobserve(filler);
        });
      },
      {
        threshold: 0.35
      }
    );

    observer.observe(filler);
  });
}

document.addEventListener('DOMContentLoaded', initNankureProductGridFillers);
document.addEventListener('shopify:section:load', initNankureProductGridFillers);

/* =========================================
   COLLECTION RITUAL - SCROLL CONTINUO
========================================= */

/*
  Arquitectura aprobada para esta sección:

  - .nankure-collection-ritual es un TRACK alto (--ritual-track-height).
  - .nankure-collection-ritual__stage es una ventana de 100svh con
    position: sticky, que permanece quieta mientras el track avanza.
  - ScrollTrigger NO bloquea el scroll: solo lee el progreso (scrub)
    y traslada los vídeos de abajo arriba de forma continua.

  Sustituye al sistema anterior de pasos bloqueados (scroll hijacking
  con wheel/touch/keydown), que obligaba a varios gestos con pausas.

  No se usa pin: true. El scroll del usuario siempre es el nativo.
*/

const NANKURE_RITUAL_MEDIA_TRIGGER_ID = 'nankure-collection-ritual-media';
const NANKURE_RITUAL_TITLE_TRIGGER_ID = 'nankure-collection-ritual-title';

/*
  RECORRIDO DE CADA VÍDEO

  Medido sobre docs/references/figma/videos/productos.mov, que está a
  escala 1:1 en un viewport de 1261 x 712.

  En la referencia los seis vídeos NO se mueven en bloque: cada uno
  arranca a una altura distinta y viaja a una velocidad distinta. Eso es
  lo que hace que se separen, se crucen y se solapen entre ellos en vez
  de llegar todos juntos formando una composición rígida.

  Sobre la referencia se midió, para cada vídeo, la posición de su borde
  superior fotograma a fotograma. Los cocientes de desplazamiento entre
  vídeos salen constantes (±0.02), así que el movimiento es un paralaje
  limpio y se puede describir con dos números por vídeo:

    start  = altura de partida, en alturas de stage (1 = borde inferior)
    travel = distancia total recorrida, en alturas de stage

  Velocidades relativas medidas: frasco 1.00, espalda 0.96, rastas y
  spray 0.98, rubia 0.54, mejilla 0.33. Las dos lentas se quedan
  rezagadas y siguen en pantalla cuando la sección empieza a salir,
  igual que en la referencia.

  Para acelerar o frenar el conjunto no hay que tocar estos valores:
  se ajusta --ritual-track-height en el CSS.
*/
const NANKURE_RITUAL_FLOW = {
  'left-third':  { start: 1.148, travel: 2.669 },   // mujer con frasco   (1ª izq.)
  'right-third': { start: 1.053, travel: 2.562 },   // espalda mojada     (1ª dcha.)
  'left-bottom': { start: 1.006, travel: 0.881 },   // mujer mejilla      (2ª izq., lenta)
  'right-back':  { start: 1.138, travel: 1.441 },   // rubia rizada       (2ª dcha., lenta)
  'left-top':    { start: 1.761, travel: 2.616 },   // mujer rastas       (3ª izq.)
  'right-front': { start: 1.846, travel: 2.616 }    // mujer con spray    (3ª dcha.)
};

function nankureRitualFlowKey(element) {
  const match = Array.from(element.classList)
    .find((name) => name.startsWith('nankure-collection-ritual__media--'));

  return match
    ? match.replace('nankure-collection-ritual__media--', '')
    : null;
}

function initNankureRitualScrollEffect() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.nankure-collection-ritual[data-nankure-ritual-steps]');
  const stage = section?.querySelector('.nankure-collection-ritual__stage');
  const title = section?.querySelector('.nankure-collection-ritual__title');

  if (!section || !stage || !title) return;
  if (section.dataset.ritualReady === 'true') return;

  const media = Array.from(section.querySelectorAll('[data-ritual-video]'));
  if (!media.length) return;

  section.dataset.ritualReady = 'true';

  /*
    El recorrido se mide sobre el stage y no sobre window.innerHeight
    para que las barras dinámicas de Safari/iOS no lo cambien a mitad
    de scroll.
  */
  const stageHeight = () => stage.offsetHeight || window.innerHeight;

  const flowOf = (element) => {
    const key = nankureRitualFlowKey(element);

    return (key && NANKURE_RITUAL_FLOW[key]) || { start: 1.1, travel: 2.6 };
  };

  ScrollTrigger.getById(NANKURE_RITUAL_MEDIA_TRIGGER_ID)?.kill(true);
  ScrollTrigger.getById(NANKURE_RITUAL_TITLE_TRIGGER_ID)?.kill(true);
  ScrollTrigger.getById('nankure-ritual-video-steps')?.kill(true);

  media.forEach((element) => {
    const flow = flowOf(element);

    gsap.set(element, {
      y: () => stageHeight() * flow.start,
      opacity: 1,
      force3D: true
    });
  });

  const timeline = gsap.timeline({
    defaults: {
      ease: 'none'
    }
  });

  media.forEach((element) => {
    const flow = flowOf(element);

    timeline.fromTo(
      element,
      {
        y: () => stageHeight() * flow.start
      },
      {
        y: () => stageHeight() * (flow.start - flow.travel),
        duration: 1
      },
      0
    );
  });

  /*
    start 'top top'       -> el stage acaba de quedarse pegado.
    end   'bottom bottom' -> el stage deja de estar pegado.

    Los dos vídeos lentos siguen visibles al llegar al final y salen
    arrastrados por la propia sección, como en la referencia.
  */
  ScrollTrigger.create({
    id: NANKURE_RITUAL_MEDIA_TRIGGER_ID,
    trigger: section,
    start: 'top top',
    end: 'bottom bottom',
    scrub: 0.6,
    invalidateOnRefresh: true,
    animation: timeline
  });

  /*
    El título aparece al entrar la sección y se mantiene visible.
    Al vivir dentro del stage sticky ya no necesita estados fixed.
  */
  ScrollTrigger.create({
    id: NANKURE_RITUAL_TITLE_TRIGGER_ID,
    trigger: section,
    start: 'top 85%',
    end: 'bottom top',
    invalidateOnRefresh: true,
    onEnter: () => title.classList.add('is-visible'),
    onLeaveBack: () => title.classList.remove('is-visible')
  });

  requestAnimationFrame(() => {
    ScrollTrigger.refresh();
  });
}

window.addEventListener('load', () => {
  setTimeout(initNankureRitualScrollEffect, 300);
});

document.addEventListener('shopify:section:load', () => {
  setTimeout(initNankureRitualScrollEffect, 300);
});

/* =========================================
   PRODUCT TEMPLATE - VARIANTS + QUANTITY
========================================= */

function initNankureProductTemplate() {
  const productPage = document.querySelector('.nankure-product-page');
  if (!productPage || productPage.dataset.productReady === 'true') return;

  productPage.dataset.productReady = 'true';

  const variantInput = productPage.querySelector('.nankure-product-form__variant-id');
  const variantButtons = productPage.querySelectorAll('.nankure-product-hero__variant-button');
  const priceEl = productPage.querySelector('.nankure-product-form__price');
  const qtyInput = productPage.querySelector('.nankure-product-form__qty-input');
  const minusBtn = productPage.querySelector('[data-qty-minus]');
  const plusBtn = productPage.querySelector('[data-qty-plus]');
  const submitBtn = productPage.querySelector('.nankure-product-form__submit');

  const variants = window.NANKURE_PRODUCT_VARIANTS || [];

  function updateSubmitButton(variant) {
    if (!submitBtn || !variant) return;

    if (variant.available) {
      submitBtn.disabled = false;
      submitBtn.classList.remove('is-disabled');
      submitBtn.textContent = 'AÑADIR AL CARRITO';
    } else {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-disabled');
      submitBtn.textContent = 'SIN STOCK';
    }
  }

  if (minusBtn && qtyInput) {
    minusBtn.addEventListener('click', () => {
      const current = parseInt(qtyInput.value || '1', 10);
      qtyInput.value = Math.max(1, current - 1);
    });
  }

  if (plusBtn && qtyInput) {
    plusBtn.addEventListener('click', () => {
      const current = parseInt(qtyInput.value || '1', 10);
      qtyInput.value = current + 1;
    });
  }

  if (!variantButtons.length || !variants.length || !variantInput) {
    if (variants.length) {
      updateSubmitButton(variants[0]);
    }

    return;
  }

  const selectedOptions = {};

  variantButtons.forEach((button) => {
    const position = button.dataset.optionPosition;
    const value = button.dataset.optionValue;

    if (button.classList.contains('is-active')) {
      selectedOptions[position] = value;
    }
  });

  function updateSelectedVariant() {
    const matchedVariant = variants.find((variant) => {
      return variant.options.every((optionValue, index) => {
        return selectedOptions[String(index + 1)] === optionValue;
      });
    });

    if (!matchedVariant) return;

    variantInput.value = matchedVariant.id;

    if (priceEl) {
      priceEl.innerHTML = matchedVariant.formatted_price;
    }

    updateSubmitButton(matchedVariant);
  }

  variantButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const buttonPosition = button.dataset.optionPosition;

      productPage
        .querySelectorAll(`.nankure-product-hero__variant-button[data-option-position="${buttonPosition}"]`)
        .forEach((item) => item.classList.remove('is-active'));

      button.classList.add('is-active');

      selectedOptions[buttonPosition] = button.dataset.optionValue;

      updateSelectedVariant();
    });
  });

  updateSelectedVariant();
}

document.addEventListener('DOMContentLoaded', initNankureProductTemplate);
window.addEventListener('load', initNankureProductTemplate);
document.addEventListener('shopify:section:load', initNankureProductTemplate);

/* =========================================
   PRODUCT TEMPLATE - IMAGE INTRO SCALE
========================================= */

function initNankureProductImageIntro() {
  const productPage = document.querySelector('.nankure-product-page');

  if (!productPage || productPage.classList.contains('product-gsap-ready')) return;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      productPage.classList.add('product-gsap-ready');
    });
  });
}

window.addEventListener('load', initNankureProductImageIntro);
document.addEventListener('shopify:section:load', initNankureProductImageIntro);

/* =========================================
   PRODUCT DETAILS IMAGE - SCROLL SCALE EFFECT
========================================= */

function initNankureProductDetailsImageIntro() {
  const section = document.querySelector('.nankure-product-details-section');

  if (!section || section.dataset.detailsImageReady === 'true') return;

  section.dataset.detailsImageReady = 'true';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        section.classList.add('details-image-visible');
        observer.unobserve(section);
      });
    },
    {
      threshold: 0.35
    }
  );

  observer.observe(section);
}

document.addEventListener('DOMContentLoaded', initNankureProductDetailsImageIntro);
window.addEventListener('load', initNankureProductDetailsImageIntro);
document.addEventListener('shopify:section:load', initNankureProductDetailsImageIntro);

/* =========================================
   PRODUCT RITUAL SECTION - SCROLL CONTINUO
========================================= */

/*
  Misma arquitectura que los rituales de colección y universo:

  - .nankure-product-ritual-section es un TRACK alto
    (--product-ritual-track-height).
  - .nankure-product-ritual-section__stage es una ventana de 100svh con
    position: sticky, que permanece quieta mientras el track avanza.
  - ScrollTrigger NO bloquea el scroll: solo lee el progreso (scrub) y
    traslada los dos vídeos de abajo arriba de forma continua.

  Sustituye al sistema anterior, que fijaba el título con position: fixed
  y cambiaba de estado con clases. No se usa pin: true.
*/

const NANKURE_PRODUCT_RITUAL_TRIGGER_ID = 'nankure-product-ritual-media';
const NANKURE_PRODUCT_RITUAL_TITLE_ID = 'nankure-product-ritual-title';

/*
  RECORRIDO DE CADA VÍDEO

  Medido sobre la referencia de Figma (escala 1:1, viewport 1261 x 712).
  En la composición de reposo el vídeo izquierdo tiene su borde superior
  en 278 y el derecho en 478: el derecho entra más abajo, pero viaja más
  rápido, adelanta al izquierdo y sale antes. El izquierdo se queda
  rezagado y sigue en pantalla cuando el otro ya se ha ido.

    start  = altura de partida, en alturas de stage (1 = borde inferior)
    travel = distancia total recorrida, en alturas de stage

  Están calculados para que la composición de la referencia se reproduzca
  en torno al 38% del scroll de la sección y para que al empezar no haya
  ningún vídeo todavía en pantalla.

  Para acelerar o frenar el conjunto se ajusta
  --product-ritual-track-height en el CSS.
*/
const NANKURE_PRODUCT_RITUAL_FLOW = {
  left: { start: 1.011, travel: 1.643 },
  right: { start: 1.626, travel: 2.528 }
};

function nankureProductRitualFlowKey(element) {
  return element.classList.contains('nankure-product-ritual-section__media--right')
    ? 'right'
    : 'left';
}

function initNankureProductRitualScrollEffect() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.nankure-product-ritual-section[data-nankure-product-ritual]');
  const stage = section?.querySelector('.nankure-product-ritual-section__stage');
  const title = section?.querySelector('.nankure-product-ritual-section__title');

  if (!section || !stage || !title) return;
  if (section.dataset.productRitualReady === 'true') return;

  const media = Array.from(section.querySelectorAll('[data-product-ritual-video]'));
  if (!media.length) return;

  section.dataset.productRitualReady = 'true';

  /*
    El recorrido se mide sobre el stage y no sobre window.innerHeight para
    que las barras dinámicas de Safari/iOS no lo cambien a mitad de scroll.
  */
  const stageHeight = () => stage.offsetHeight || window.innerHeight;

  const flowOf = (element) => NANKURE_PRODUCT_RITUAL_FLOW[nankureProductRitualFlowKey(element)];

  ScrollTrigger.getById(NANKURE_PRODUCT_RITUAL_TRIGGER_ID)?.kill(true);
  ScrollTrigger.getById(NANKURE_PRODUCT_RITUAL_TITLE_ID)?.kill(true);

  media.forEach((element) => {
    const flow = flowOf(element);

    gsap.set(element, {
      y: () => stageHeight() * flow.start,
      opacity: 1,
      force3D: true
    });
  });

  const timeline = gsap.timeline({
    defaults: {
      ease: 'none'
    }
  });

  media.forEach((element) => {
    const flow = flowOf(element);

    timeline.fromTo(
      element,
      {
        y: () => stageHeight() * flow.start
      },
      {
        y: () => stageHeight() * (flow.start - flow.travel),
        duration: 1
      },
      0
    );
  });

  ScrollTrigger.create({
    id: NANKURE_PRODUCT_RITUAL_TRIGGER_ID,
    trigger: section,
    start: 'top top',
    end: 'bottom bottom',
    scrub: 0.6,
    invalidateOnRefresh: true,
    animation: timeline
  });

  requestAnimationFrame(() => {
    ScrollTrigger.refresh();
  });
}

window.addEventListener('load', () => {
  setTimeout(initNankureProductRitualScrollEffect, 300);
});

document.addEventListener('shopify:section:load', () => {
  setTimeout(initNankureProductRitualScrollEffect, 300);
});

/* =========================================
   PACK HORIZONTAL IMAGE - SCROLL REVEAL
========================================= */

function initNankurePackHorizontalReveal() {
  const section = document.querySelector('.nankure-pack-horizontal-section');

  if (!section || section.dataset.packHorizontalReady === 'true') return;

  section.dataset.packHorizontalReady = 'true';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        section.classList.add('is-visible');
        observer.unobserve(section);
      });
    },
    {
      threshold: 0.45
    }
  );

  observer.observe(section);
}

document.addEventListener('DOMContentLoaded', initNankurePackHorizontalReveal);
window.addEventListener('load', initNankurePackHorizontalReveal);
document.addEventListener('shopify:section:load', initNankurePackHorizontalReveal);

/* =========================================
   HOME INTRO - TEXT REVEAL
========================================= */

function initNankureHomeIntro() {
  const section = document.querySelector('.nankure-home-intro');

  if (!section || section.dataset.homeIntroReady === 'true') return;

  section.dataset.homeIntroReady = 'true';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        section.classList.add('is-visible');
        observer.unobserve(section);
      });
    },
    {
      threshold: 0.35
    }
  );

  observer.observe(section);
}

document.addEventListener('DOMContentLoaded', initNankureHomeIntro);
window.addEventListener('load', initNankureHomeIntro);
document.addEventListener('shopify:section:load', initNankureHomeIntro);

function initNankureCollectionHeroTitle() {
  const title = document.querySelector('.nankure-collection-hero__title');

  if (!title || title.dataset.titleReady === 'true') return;

  title.dataset.titleReady = 'true';

  const originalWords = Array.from(title.children);

  originalWords.forEach((item) => {
    if (item.classList.contains('nankure-title-word-mask') ||
        item.classList.contains('nankure-collection-hero__subtitle')) return;

    const mask = document.createElement('span');
    mask.className = 'nankure-title-word-mask';

    const word = document.createElement('span');
    word.className = 'nankure-title-word';
    word.innerHTML = item.innerHTML;

    mask.appendChild(word);
    item.replaceWith(mask);
  });

  title.classList.add('is-ready');

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      title.classList.add('is-visible');
    });
  });
}

document.addEventListener('DOMContentLoaded', initNankureCollectionHeroTitle);
window.addEventListener('load', initNankureCollectionHeroTitle);
document.addEventListener('shopify:section:load', initNankureCollectionHeroTitle);

/* =========================================
   PRODUCT PAGE - ENTER FROM BOTTOM
========================================= */

function initNankureProductPageEnter() {
  const productPage = document.querySelector('.nankure-product-page');

  if (!productPage || productPage.dataset.pageEnterReady === 'true') return;

  productPage.dataset.pageEnterReady = 'true';

  setTimeout(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        productPage.classList.add('product-page-enter-ready');

        setTimeout(() => {
          productPage.classList.add('product-page-enter-done');

          if (typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.refresh();
          }

          if (typeof initNankureProductRitualScrollEffect === 'function') {
            initNankureProductRitualScrollEffect();
          }

          if (typeof initNankureRitualScrollEffect === 'function') {
            initNankureRitualScrollEffect();
          }
        }, 1900);
      });
    });
  }, 450);
}

document.addEventListener('DOMContentLoaded', initNankureProductPageEnter);
window.addEventListener('load', initNankureProductPageEnter);
document.addEventListener('shopify:section:load', initNankureProductPageEnter);

/* =========================================
   UNIVERSO NANKURE - HERO TITLE REVEAL
========================================= */

function initNankureUniverseHeroTitle() {
  const title = document.querySelector('.nankure-universe-hero__title');

  if (!title || title.dataset.titleReady === 'true') return;

  title.dataset.titleReady = 'true';

  const originalWords = Array.from(title.children);

  originalWords.forEach((item) => {
    if (item.classList.contains('nankure-title-word-mask')) return;

    const mask = document.createElement('span');
    mask.className = 'nankure-title-word-mask';

    const word = document.createElement('span');
    word.className = 'nankure-title-word';
    word.innerHTML = item.innerHTML;

    mask.appendChild(word);
    item.replaceWith(mask);
  });

  title.classList.add('is-ready');

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      title.classList.add('is-visible');
    });
  });
}

document.addEventListener('DOMContentLoaded', initNankureUniverseHeroTitle);
window.addEventListener('load', initNankureUniverseHeroTitle);
document.addEventListener('shopify:section:load', initNankureUniverseHeroTitle);


/* =========================================
   UNIVERSO NANKURE - COVER IMAGE SCALE
========================================= */

function initNankureUniverseCoverReveal() {
  const section = document.querySelector('.nankure-universe-cover');

  if (!section || section.dataset.coverReady === 'true') return;

  section.dataset.coverReady = 'true';

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        section.classList.add('is-visible');
        obs.unobserve(section);
      });
    },
    {
      threshold: 0.35
    }
  );

  observer.observe(section);
}

document.addEventListener('DOMContentLoaded', initNankureUniverseCoverReveal);
window.addEventListener('load', initNankureUniverseCoverReveal);
document.addEventListener('shopify:section:load', initNankureUniverseCoverReveal);

/* =========================================
   UNIVERSO NANKURE - RITUAL SCROLL CONTINUO
========================================= */

/*
  Misma arquitectura que el ritual de colección:

  - .nankure-universe-ritual es un TRACK alto (--universe-track-height).
  - .nankure-universe-ritual__stage es una ventana de 100svh con
    position: sticky, que permanece quieta mientras el track avanza.
  - ScrollTrigger NO bloquea el scroll: solo lee el progreso (scrub) y
    traslada las imágenes de abajo arriba de forma continua.

  Sustituye al sistema anterior de pasos bloqueados (scroll hijacking con
  wheel/touch/keydown). No se usa pin: true.
*/

const NANKURE_UNIVERSE_MEDIA_TRIGGER_ID = 'nankure-universe-ritual-media';
const NANKURE_UNIVERSE_TITLE_TRIGGER_ID = 'nankure-universe-ritual-title';

/*
  RECORRIDO DE CADA IMAGEN

  La composición de reposo está medida sobre la referencia de Figma
  (docs/references/figma/screenshots/universo-nankure/, 1261 x 712). En
  ella las seis imágenes forman una cascada con estos bordes superiores:

    roca 44 · arena 92 · mármol 290 · agua 292 · pelo 537 · musgo 599

  Comparando dos momentos distintos de la referencia se ve que no se
  mueven en bloque: pelo y musgo se desplazan unas 2.7 veces más que
  mármol y agua. Esos dos últimos son los "lentos" que se quedan
  rezagados y a los que los demás adelantan.

  De ahí los dos números por imagen:

    start  = altura de partida, en alturas de stage (1 = borde inferior)
    travel = distancia total recorrida, en alturas de stage

  Están calculados para que la composición de la referencia se reproduzca
  exacta en torno al 57% del scroll de la sección, y para que al empezar
  no haya ninguna imagen todavía en pantalla.

  Velocidades relativas medidas: musgo 1.00, arena y roca 0.95, pelo 0.90,
  mármol y agua 0.35. Ese contraste es el que hace que el musgo adelante
  al agua hacia el final, tal y como se ve en la referencia.

  Para acelerar o frenar el conjunto no hay que tocar estos valores:
  se ajusta --universe-track-height en el CSS.
*/
const NANKURE_UNIVERSE_FLOW = {
  'left-bottom': { start: 1.000, travel: 1.032 },   // mármol  (Frame_51, lenta)
  'right-third': { start: 1.003, travel: 1.032 },   // agua    (Frame_49, lenta)
  'right-front': { start: 1.671, travel: 2.802 },   // roca    (Frame_48)
  'left-top':    { start: 1.739, travel: 2.802 },   // arena   (Frame_138_1)
  'left-third':  { start: 2.278, travel: 2.654 },   // pelo    (Frame_52)
  'right-back':  { start: 2.535, travel: 2.949 }    // musgo   (Frame_50)
};

function nankureUniverseFlowKey(element) {
  const match = Array.from(element.classList)
    .find((name) => name.startsWith('nankure-universe-ritual__media--'));

  return match
    ? match.replace('nankure-universe-ritual__media--', '')
    : null;
}

function initNankureUniverseRitualScrollEffect() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.nankure-universe-ritual[data-nankure-universe-ritual-steps]');
  const stage = section?.querySelector('.nankure-universe-ritual__stage');
  const title = section?.querySelector('.nankure-universe-ritual__title');

  if (!section || !stage || !title) return;
  if (section.dataset.universeRitualReady === 'true') return;

  const media = Array.from(section.querySelectorAll('[data-universe-ritual-image]'));
  if (!media.length) return;

  section.dataset.universeRitualReady = 'true';

  /*
    El recorrido se mide sobre el stage y no sobre window.innerHeight para
    que las barras dinámicas de Safari/iOS no lo cambien a mitad de scroll.
  */
  const stageHeight = () => stage.offsetHeight || window.innerHeight;

  const flowOf = (element) => {
    const key = nankureUniverseFlowKey(element);

    return (key && NANKURE_UNIVERSE_FLOW[key]) || { start: 1.2, travel: 2.3 };
  };

  ScrollTrigger.getById(NANKURE_UNIVERSE_MEDIA_TRIGGER_ID)?.kill(true);
  ScrollTrigger.getById(NANKURE_UNIVERSE_TITLE_TRIGGER_ID)?.kill(true);
  ScrollTrigger.getById('nankure-universe-ritual-steps')?.kill(true);

  media.forEach((element) => {
    const flow = flowOf(element);

    gsap.set(element, {
      y: () => stageHeight() * flow.start,
      opacity: 1,
      force3D: true
    });
  });

  const timeline = gsap.timeline({
    defaults: {
      ease: 'none'
    }
  });

  media.forEach((element) => {
    const flow = flowOf(element);

    timeline.fromTo(
      element,
      {
        y: () => stageHeight() * flow.start
      },
      {
        y: () => stageHeight() * (flow.start - flow.travel),
        duration: 1
      },
      0
    );
  });

  /*
    start 'top top'       -> el stage acaba de quedarse pegado.
    end   'bottom bottom' -> el stage deja de estar pegado.
  */
  ScrollTrigger.create({
    id: NANKURE_UNIVERSE_MEDIA_TRIGGER_ID,
    trigger: section,
    start: 'top top',
    end: 'bottom bottom',
    scrub: 0.6,
    invalidateOnRefresh: true,
    animation: timeline
  });

  ScrollTrigger.create({
    id: NANKURE_UNIVERSE_TITLE_TRIGGER_ID,
    trigger: section,
    start: 'top 85%',
    end: 'bottom top',
    invalidateOnRefresh: true,
    onEnter: () => title.classList.add('is-visible'),
    onLeaveBack: () => title.classList.remove('is-visible')
  });

  requestAnimationFrame(() => {
    ScrollTrigger.refresh();
  });
}

window.addEventListener('load', () => {
  setTimeout(initNankureUniverseRitualScrollEffect, 300);
});

document.addEventListener('shopify:section:load', () => {
  setTimeout(initNankureUniverseRitualScrollEffect, 300);
});

/* =========================================
   ÁREA PROFESIONAL - HERO TITLE REVEAL
========================================= */

function initNankureProfessionalHeroReveal() {
  const title = document.querySelector('.nankure-professional-hero__title');

  if (!title) return;
  if (title.dataset.professionalHeroReady === 'true') return;

  title.dataset.professionalHeroReady = 'true';

  const lines = Array.from(
    title.querySelectorAll('.nankure-professional-hero__title-group > span')
  );

  lines.forEach((line) => {
    const text = line.textContent.trim();

    line.innerHTML = `
      <span class="nankure-professional-title-word-mask">
        <span class="nankure-professional-title-word">${text}</span>
      </span>
    `;
  });

  title.classList.add('is-ready');

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      title.classList.add('is-visible');
    });
  });
}

/* =========================================
   ÁREA PROFESIONAL - COVER IMAGE SCALE
========================================= */

function initNankureProfessionalCoverReveal() {
  const cover = document.querySelector('.nankure-professional-cover');

  if (!cover) return;
  if (cover.dataset.professionalCoverReady === 'true') return;

  cover.dataset.professionalCoverReady = 'true';

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        cover.classList.add('is-visible');
        observer.unobserve(cover);
      });
    },
    {
      threshold: 0.35
    }
  );

  observer.observe(cover);
}

/* =========================================
   ÁREA PROFESIONAL - INIT
========================================= */

function initNankureProfessionalPage() {
  initNankureProfessionalHeroReveal();
  initNankureProfessionalCoverReveal();
}

window.addEventListener('load', () => {
  setTimeout(initNankureProfessionalPage, 300);
});

document.addEventListener('shopify:section:load', () => {
  setTimeout(initNankureProfessionalPage, 300);
});

/* =========================================
   ÁREA PROFESIONAL - CARDS SCROLL CONTINUO
========================================= */

/*
  Misma arquitectura que los rituales de colección y universo:

  - .nankure-professional-cards es un TRACK alto
    (--professional-track-height).
  - .nankure-professional-cards__inner hace de stage: una ventana de
    100svh con position: sticky que permanece quieta mientras el track
    avanza. Aquí no hace falta envoltorio nuevo en el Liquid porque ese
    elemento ya existía.
  - ScrollTrigger NO bloquea el scroll: solo lee el progreso (scrub) y
    interpola entre los cuatro estados de la baraja.

  Sustituye al sistema anterior de pasos bloqueados (scroll hijacking con
  wheel/touch/keydown), que obligaba a un gesto por tarjeta con pausas.
  No se usa pin: true.

  Los cuatro estados son exactamente los que antes vivían en el CSS como
  .is-step-0 … .is-step-3. Se han traído aquí porque ahora hay que
  interpolar entre ellos, no saltar de uno a otro. El .is-step-0 del CSS
  se conserva como estado inicial antes de que arranque el JS.
*/

const NANKURE_PROFESSIONAL_TRIGGER_ID = 'nankure-professional-cards';

/*
  Estado de cada tarjeta en cada uno de los cuatro pasos.

    x, y      desplazamiento en px
    yPercent  -50 centra la tarjeta; -165 la saca por arriba (móvil)
    scale     solo cambia en móvil
    opacity   entradas y salidas
    zIndex    en escritorio es fijo; en móvil cambia en cada relevo
*/
const NANKURE_PROFESSIONAL_STEPS = {
  desktop: {
    '01': [
      { x: -24, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 },
      { x: -470, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 },
      { x: -535, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 },
      { x: -535, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 }
    ],
    '02': [
      { x: 34, y: 20, yPercent: -50, scale: 1, opacity: 1, zIndex: 3 },
      { x: 0, y: 20, yPercent: -50, scale: 1, opacity: 1, zIndex: 3 },
      { x: -190, y: 20, yPercent: -50, scale: 1, opacity: 1, zIndex: 3 },
      { x: -190, y: 20, yPercent: -50, scale: 1, opacity: 1, zIndex: 3 }
    ],
    '03': [
      { x: 68, y: 35, yPercent: -50, scale: 1, opacity: 0, zIndex: 2 },
      { x: 60, y: 35, yPercent: -50, scale: 1, opacity: 0, zIndex: 2 },
      { x: 130, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 2 },
      { x: 130, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 2 }
    ],
    '04': [
      { x: 102, y: 50, yPercent: -50, scale: 1, opacity: 0, zIndex: 1 },
      { x: 100, y: 50, yPercent: -50, scale: 1, opacity: 0, zIndex: 1 },
      { x: 190, y: 30, yPercent: -50, scale: 1, opacity: 0, zIndex: 1 },
      { x: 475, y: 20, yPercent: -50, scale: 1, opacity: 1, zIndex: 1 }
    ]
  },

  /* 768 – 1280: misma coreografía, la baraja se abre menos */
  tablet: {
    '01': [
      { x: -24, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 },
      { x: -365, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 },
      { x: -405, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 },
      { x: -405, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 }
    ],
    '02': [
      { x: 34, y: 20, yPercent: -50, scale: 1, opacity: 1, zIndex: 3 },
      { x: 0, y: 20, yPercent: -50, scale: 1, opacity: 1, zIndex: 3 },
      { x: -135, y: 20, yPercent: -50, scale: 1, opacity: 1, zIndex: 3 },
      { x: -135, y: 20, yPercent: -50, scale: 1, opacity: 1, zIndex: 3 }
    ],
    '03': [
      { x: 68, y: 35, yPercent: -50, scale: 1, opacity: 0, zIndex: 2 },
      { x: 60, y: 35, yPercent: -50, scale: 1, opacity: 0, zIndex: 2 },
      { x: 135, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 2 },
      { x: 135, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 2 }
    ],
    '04': [
      { x: 102, y: 50, yPercent: -50, scale: 1, opacity: 0, zIndex: 1 },
      { x: 100, y: 50, yPercent: -50, scale: 1, opacity: 0, zIndex: 1 },
      { x: 190, y: 30, yPercent: -50, scale: 1, opacity: 0, zIndex: 1 },
      { x: 405, y: 20, yPercent: -50, scale: 1, opacity: 1, zIndex: 1 }
    ]
  },

  /* <=767: baraja vertical, cada tarjeta sale por arriba y cede el turno */
  mobile: {
    '01': [
      { x: 0, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 },
      { x: 0, y: 0, yPercent: -165, scale: 1, opacity: 0, zIndex: 1 },
      { x: 0, y: 0, yPercent: -165, scale: 1, opacity: 0, zIndex: 1 },
      { x: 0, y: 0, yPercent: -165, scale: 1, opacity: 0, zIndex: 1 }
    ],
    '02': [
      { x: 0, y: 26, yPercent: -50, scale: 0.96, opacity: 1, zIndex: 3 },
      { x: 0, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 },
      { x: 0, y: 0, yPercent: -165, scale: 1, opacity: 0, zIndex: 1 },
      { x: 0, y: 0, yPercent: -165, scale: 1, opacity: 0, zIndex: 1 }
    ],
    '03': [
      { x: 0, y: 52, yPercent: -50, scale: 0.92, opacity: 1, zIndex: 2 },
      { x: 0, y: 26, yPercent: -50, scale: 0.96, opacity: 1, zIndex: 3 },
      { x: 0, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 },
      { x: 0, y: 0, yPercent: -165, scale: 1, opacity: 0, zIndex: 1 }
    ],
    '04': [
      { x: 0, y: 78, yPercent: -50, scale: 0.88, opacity: 1, zIndex: 1 },
      { x: 0, y: 52, yPercent: -50, scale: 0.92, opacity: 1, zIndex: 2 },
      { x: 0, y: 26, yPercent: -50, scale: 0.96, opacity: 1, zIndex: 3 },
      { x: 0, y: 0, yPercent: -50, scale: 1, opacity: 1, zIndex: 4 }
    ]
  }
};

function nankureProfessionalStepSet() {
  if (window.matchMedia('(max-width: 767px)').matches) return NANKURE_PROFESSIONAL_STEPS.mobile;
  if (window.matchMedia('(max-width: 1280px)').matches) return NANKURE_PROFESSIONAL_STEPS.tablet;

  return NANKURE_PROFESSIONAL_STEPS.desktop;
}

function initNankureProfessionalCardsScroll() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.nankure-professional-cards[data-nankure-professional-cards]');
  const stage = section?.querySelector('.nankure-professional-cards__inner');

  if (!section || !stage) return;
  if (section.dataset.professionalCardsReady === 'true') return;

  const cards = Array.from(section.querySelectorAll('[data-professional-card]'));
  if (!cards.length) return;

  section.dataset.professionalCardsReady = 'true';

  const keyOf = (card) => {
    const match = Array.from(card.classList)
      .find((name) => name.startsWith('nankure-professional-card--'));

    return match ? match.replace('nankure-professional-card--', '') : null;
  };

  const stateOf = (card, step) => {
    const key = keyOf(card);
    const set = nankureProfessionalStepSet();

    return (key && set[key] && set[key][step]) || null;
  };

  ScrollTrigger.getById(NANKURE_PROFESSIONAL_TRIGGER_ID)?.kill(true);

  cards.forEach((card) => {
    const state = stateOf(card, 0);
    if (!state) return;

    gsap.set(card, {
      xPercent: -50,
      x: () => stateOf(card, 0).x,
      y: () => stateOf(card, 0).y,
      yPercent: () => stateOf(card, 0).yPercent,
      scale: () => stateOf(card, 0).scale,
      opacity: () => stateOf(card, 0).opacity,
      zIndex: state.zIndex,
      force3D: true
    });
  });

  /*
    Tres tramos (0→1, 1→2, 2→3) de duración 1 cada uno.
    El z-index se aplica con .set() porque no admite valores intermedios.
  */
  const timeline = gsap.timeline({
    defaults: {
      ease: 'none',
      duration: 1
    }
  });

  for (let step = 1; step <= 3; step += 1) {
    cards.forEach((card) => {
      timeline.to(card, {
        x: () => stateOf(card, step).x,
        y: () => stateOf(card, step).y,
        yPercent: () => stateOf(card, step).yPercent,
        scale: () => stateOf(card, step).scale,
        opacity: () => stateOf(card, step).opacity
      }, step - 1);

      /*
        El z-index se aplica al FINAL del tramo, no al principio: mientras
        una tarjeta sale hacia arriba tiene que seguir por delante de las
        demás, y solo pasa al fondo una vez ha salido.
      */
      timeline.set(card, {
        zIndex: () => stateOf(card, step).zIndex
      }, step);
    });
  }

  section.classList.add('is-cards-ready');

  ScrollTrigger.create({
    id: NANKURE_PROFESSIONAL_TRIGGER_ID,
    trigger: section,
    start: 'top top',
    end: 'bottom bottom',
    scrub: 0.6,
    invalidateOnRefresh: true,
    animation: timeline
  });

  requestAnimationFrame(() => {
    ScrollTrigger.refresh();
  });
}

window.addEventListener('load', () => {
  setTimeout(initNankureProfessionalCardsScroll, 300);
});

document.addEventListener('shopify:section:load', () => {
  setTimeout(initNankureProfessionalCardsScroll, 300);
});

/* =========================================
   NANKURE CART DRAWER OVERRIDE - STABLE
========================================= */

(function () {
  const CART_DIALOG_SELECTOR = '.cart-drawer__dialog';
  const LATEST_PRODUCT_DATA_SELECTOR = '[data-nankure-latest-product]';

  let isRendering = false;
  let renderTimer = null;
  let cachedLatestProduct = null;

  function getDialog() {
    return document.querySelector(CART_DIALOG_SELECTOR);
  }

  function cartIsEmpty(dialog) {
    return dialog?.classList.contains('cart-drawer--empty');
  }

  function getCount(dialog) {
    const countEl = dialog?.querySelector('.cart-bubble__text-count:not(.hidden), [data-testid="cart-bubble"]:not(.hidden)');
    const count = parseInt(countEl?.textContent?.trim() || '0', 10);

    if (!Number.isNaN(count) && count > 0) return count;

    const rows = dialog?.querySelectorAll('.cart-items__table-row') || [];

    return rows.length;
  }

  function getLatestProduct() {
    if (cachedLatestProduct) return cachedLatestProduct;

    const dataEl = document.querySelector(LATEST_PRODUCT_DATA_SELECTOR);

    if (dataEl) {
      try {
        const parsed = JSON.parse(dataEl.textContent);

        cachedLatestProduct = {
          title: parsed?.title || 'Pack Kalagua',
          handle: parsed?.handle || '',
          image: parsed?.image || '',
          variantId: parsed?.variantId || null
        };

        return cachedLatestProduct;
      } catch (error) {
        // El JSON renderizado por Liquid es inválido: cae al fallback de abajo.
      }
    }

    cachedLatestProduct = {
      title: 'Pack Kalagua',
      handle: 'pack-ritual',
      image: 'https://cdn.shopify.com/s/files/1/1016/5574/0764/files/Minisproductos.jpg?v=1779098915',
      variantId: null
    };

    return cachedLatestProduct;
  }

  function setHeader(dialog) {
    const heading =
      dialog.querySelector('#cart-drawer-heading') ||
      dialog.querySelector('#cart-drawer-heading-empty') ||
      dialog.querySelector('.cart-drawer__heading');

    if (!heading) return;

    const count = getCount(dialog);
    const empty = cartIsEmpty(dialog);

    heading.dataset.nankureCartSubtitle = empty ? 'Tu carrito está vacío' : `${count} Artículos`;

    Array.from(heading.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = '';
      }
    });

    if (!heading.querySelector('[data-nankure-cart-title]')) {
      const title = document.createElement('span');
      title.dataset.nankureCartTitle = 'true';
      title.textContent = 'TU CARRITO';
      heading.prepend(title);
    }
  }

  function buildRecommended(product) {
    const image = product.image ? `<img src="${product.image}" alt="">` : '';

    return `
      <div class="nankure-cart-recommended" data-nankure-cart-recommended>
        <div class="nankure-cart-recommended__image">${image}</div>

        <div class="nankure-cart-recommended__content">
          <p class="nankure-cart-recommended__title">${product.title}</p>
          <p class="nankure-cart-recommended__subtitle">Completa tu ritual</p>
        </div>

        <button
          type="button"
          class="nankure-cart-recommended__add"
          data-nankure-cart-add
          ${product.variantId ? `data-variant-id="${product.variantId}"` : 'disabled'}
        >
          Añadir
        </button>
      </div>
    `;
  }

  function buildPayments() {
    const iconsWrapper = document.querySelector('.payment-icons');

    if (!iconsWrapper || !iconsWrapper.querySelector('.payment-icons__list')?.children.length) {
      return '';
    }

    return `
      <div class="nankure-cart-payments" data-nankure-cart-payments>
        ${iconsWrapper.outerHTML}
      </div>
    `;
  }

  function buildDisabledCheckout() {
    return `
      <div class="nankure-cart-checkout-area" data-nankure-cart-checkout-area>
        <button type="button" class="nankure-cart-checkout-disabled" disabled>
          FINALIZAR COMPRA
        </button>
      </div>
    `;
  }

  function ensureBottomTarget(dialog) {
    return dialog.querySelector('cart-items-component') || dialog.querySelector('.cart-drawer__inner');
  }

  function getNativeCheckout(dialog) {
    return dialog.querySelector('.cart__checkout-button');
  }

  function prepareNativeCheckout(button) {
    if (!button) return;

    const text = button.querySelector('.button-text');

    if (text) {
      text.textContent = 'FINALIZAR COMPRA';
    } else {
      button.textContent = 'FINALIZAR COMPRA';
    }
  }

  function renderBottom(dialog) {
    const target = ensureBottomTarget(dialog);
    if (!target) return;

    const empty = cartIsEmpty(dialog);
    let bottom = dialog.querySelector('[data-nankure-cart-bottom]');

    /*
      El morph nativo de Horizon (cart-items-component) reemplaza su propio
      subárbol en cada add/remove/cambio de cantidad, así que nuestro bloque
      inferior desaparece con él. Solo lo reconstruimos cuando de verdad
      falta o quedó huérfano de su contenedor — nunca en cada mutación.
    */
    if (!bottom || bottom.parentElement !== target) {
      if (bottom) bottom.remove();

      const product = getLatestProduct();

      bottom = document.createElement('div');
      bottom.className = 'nankure-cart-bottom';
      bottom.dataset.nankureCartBottom = 'true';

      bottom.innerHTML = `
        ${buildRecommended(product)}
        ${buildPayments()}
        <div class="nankure-cart-checkout-area" data-nankure-cart-checkout-area></div>
      `;

      target.appendChild(bottom);
    }

    const checkoutArea = bottom.querySelector('[data-nankure-cart-checkout-area]');
    if (!checkoutArea) return;

    if (empty) {
      if (!checkoutArea.querySelector('.nankure-cart-checkout-disabled')) {
        checkoutArea.outerHTML = buildDisabledCheckout();
      }

      return;
    }

    const nativeCheckout = getNativeCheckout(dialog);

    if (nativeCheckout) {
      if (nativeCheckout.parentElement !== checkoutArea) {
        prepareNativeCheckout(nativeCheckout);
        checkoutArea.appendChild(nativeCheckout);
      }
    } else if (!checkoutArea.querySelector('.cart__checkout-button')) {
      checkoutArea.innerHTML = `
        <a href="/checkout" class="cart__checkout-button button">
          <span class="button-text">FINALIZAR COMPRA</span>
        </a>
      `;
    }
  }

  function renderCart() {
    const dialog = getDialog();

    if (!dialog || isRendering) return;

    isRendering = true;

    try {
      setHeader(dialog);
      renderBottom(dialog);
    } finally {
      setTimeout(() => {
        isRendering = false;
      }, 120);
    }
  }

  function scheduleRender() {
    const dialog = getDialog();

    if (!dialog || !dialog.open) return;
    if (isRendering) return;

    window.clearTimeout(renderTimer);

    renderTimer = window.setTimeout(() => {
      renderCart();
    }, 120);
  }

  async function addProduct(button) {
    const variantId = button.getAttribute('data-variant-id');

    if (!variantId || button.dataset.loading === 'true') return;

    button.dataset.loading = 'true';
    button.disabled = true;
    button.textContent = 'Añadiendo';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      if (!response.ok) throw new Error('add failed');

      button.textContent = 'Añadido';

      /*
        Igual que el flujo nativo de Horizon (product-form.js): pedimos el
        carrito actualizado y disparamos el mismo evento 'cart:update' que
        escuchan cart-items-component (re-renderiza el drawer) y cart-icon
        (actualiza el contador). Sin recargar la página.
      */
      let cart = null;

      try {
        const cartResponse = await fetch('/cart.js', {
          credentials: 'same-origin'
        });

        if (cartResponse.ok) {
          cart = await cartResponse.json();
        }
      } catch (cartError) {
        cart = null;
      }

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'nankure-cart-recommended',
          data: {
            source: 'nankure-cart-recommended',
            itemCount: cart?.item_count ?? 0
          }
        }
      }));

      window.setTimeout(() => {
        button.dataset.loading = 'false';
        button.disabled = false;
        button.textContent = 'Añadir';
      }, 1200);
    } catch (error) {
      button.dataset.loading = 'false';
      button.disabled = false;
      button.textContent = 'Añadir';
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const addButton = event.target.closest('[data-nankure-cart-add]');

      if (addButton) {
        event.preventDefault();
        event.stopPropagation();
        addProduct(addButton);
        return;
      }
    },
    true
  );

  const observer = new MutationObserver((mutations) => {
    const shouldRender = mutations.some((mutation) => {
      if (mutation.type === 'attributes') {
        return mutation.attributeName === 'open' || mutation.attributeName === 'class';
      }

      if (mutation.type === 'childList') {
        return Array.from(mutation.addedNodes).some((node) => {
          return node.nodeType === 1 && !node.matches?.('[data-nankure-cart-bottom]') && !node.closest?.('[data-nankure-cart-bottom]');
        });
      }

      return false;
    });

    if (shouldRender) scheduleRender();
  });

  function attachCartObserver() {
    /*
      Acotado a cart-drawer-component (D-6): antes observaba
      document.documentElement, así que cualquier cambio de clase en
      cualquier parte de la página (por ejemplo is-locked/is-active de los
      rituales de scroll) disparaba este callback constantemente.
    */
    const scope = document.querySelector('cart-drawer-component') || getDialog();
    if (!scope) return;

    observer.observe(scope, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['open', 'class']
    });
  }

  attachCartObserver();

  window.addEventListener('load', () => {
    attachCartObserver();
    window.setTimeout(renderCart, 300);
  });

  document.addEventListener('shopify:section:load', () => {
    /*
      Si el Theme Editor re-renderiza la sección del header, cart-drawer-component
      se sustituye por una instancia nueva del DOM; volver a llamar a observe()
      aquí mantiene el observer enganchado al nodo actual sin duplicar nada
      (MutationObserver.observe() en el mismo nodo solo actualiza sus opciones).
    */
    attachCartObserver();
    window.setTimeout(renderCart, 300);
  });
})();

/* =========================================
   NANKURE - ACCOUNT ICON REDIRECT HARD FIX
========================================= */

document.addEventListener(
  'click',
  function (event) {
    const accountTrigger = event.target.closest(
      '.account-button, shopify-account, .account-button__icon'
    );

    if (!accountTrigger) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    window.location.href = '/pages/mi-cuenta';
  },
  true
);

/* =========================================
   NANKURE HOME - PRODUCTS STICKY + ACTIVES CLICK
========================================= */

(function () {
  const PRODUCT_TRIGGER_ID = 'nankure-home-products-sticky-track';
  let mobileShowcaseCleanup = null;

  function hasGSAP() {
    return typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
  }

  function parseJSON(el) {
    if (!el) return [];

    try {
      return JSON.parse(el.textContent.trim());
    } catch (error) {
      console.warn('Nankure JSON error', error);
      return [];
    }
  }

  function killTrigger(id) {
    if (!hasGSAP()) return;

    const trigger = ScrollTrigger.getById(id);
    if (trigger) trigger.kill(true);
  }

  function setRealViewportHeight() {
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    document.documentElement.style.setProperty('--nankure-real-vh', `${viewportHeight}px`);
  }

  /*
    D-19 [TEMPORAL — quitar tras confirmar en dispositivo real]: panel de
    diagnóstico visible en pantalla. No hay forma de inspeccionar consola
    en un iPhone sin cable/Mac, así que esto escribe los eventos del
    gesto directamente en la pantalla para poder leerlos a simple vista.
  */
  const NANKURE_SHOWCASE_DEBUG = new URLSearchParams(window.location.search).has('nkShowcaseDebug');

  function nankureShowcaseDebugLog(msg) {
    if (!NANKURE_SHOWCASE_DEBUG) return;

    console.log('[NANKURE-SHOWCASE] ' + msg);

    let panel = document.getElementById('nankure-showcase-debug');
    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'nankure-showcase-debug';
      panel.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;'
        + 'background:rgba(0,0,0,0.85);color:#3f3;font:11px/1.4 monospace;'
        + 'padding:6px 8px;max-height:32vh;overflow:hidden;pointer-events:none;'
        + 'white-space:pre-wrap;';
      document.body.appendChild(panel);
    }

    const line = document.createElement('div');
    line.textContent = msg;
    panel.appendChild(line);

    while (panel.children.length > 14) panel.removeChild(panel.firstChild);
  }

  /*
    D-8b: mismo patrón que getIndexedActiveIndex — persiste el índice
    actual en el propio DOM para que sobreviva a una reconstrucción
    (resize genuino, cruce de breakpoint, Theme Editor) sin volver
    siempre al producto 1.
  */
  function getPersistedShowcaseIndex(section, lastIndex) {
    const value = Number(section.dataset.showcaseIndex);
    if (!Number.isFinite(value)) return 0;
    return Math.max(0, Math.min(lastIndex, value));
  }

  /*
    D-16: en móvil este componente ya no intenta bloquear ni corregir la
    posición de scroll del documento. Se probaron tres variantes y las
    tres compitieron con la inercia nativa de iOS o resultaron poco
    fiables en WebKit (confirmado en dispositivo real, no en teoría):
    ScrollTrigger scrub+snap simulando un scrollTo, GSAP Observer con
    preventDefault (WebKit puede iniciar el scroll nativo antes de que
    el preventDefault del touchmove llegue a aplicarse), y Observer +
    ScrollTrigger.normalizeScroll() combinados (mismo resultado que solo
    Observer).

    En su lugar: touch-action: pan-x pinch-zoom (ver CSS) le indica al
    navegador, ANTES de que empiece cualquier gesto, que no debe iniciar
    scroll vertical nativo para toques que arrancan sobre esta sección.
    Al ser una propiedad CSS que evalúa el compositor en cuanto empieza
    el toque —no JS reaccionando después— no hay carrera posible con la
    inercia, a diferencia de preventDefault.

    Límite real (no resuelto, y no se puede resolver sin volver a tocar
    el scroll del documento): un gesto que ya empezó ANTES de llegar a
    esta sección —el usuario venía haciendo scroll y la inercia lo trae
    hasta aquí con el dedo ya levantado— sigue siendo scroll nativo del
    documento; touch-action no puede apropiárselo a mitad de camino. En
    cuanto ese scroll se asienta, el siguiente toque si empieza sobre la
    sección y queda capturado con normalidad.

    Ciclo de gesto con Pointer Events:
    - pointerdown: guarda pointerId y coordenadas; no decide eje todavía
      (así un tap sobre la tarjeta sigue funcionando sin interferencia).
    - pointermove: hasta superar INTENT_THRESHOLD no se decide si el
      gesto es vertical u horizontal. En cuanto se decide vertical y se
      supera TRIGGER_THRESHOLD, el gesto se marca consumido de inmediato:
      ya no puede volver a disparar un paso aunque el dedo se siga
      moviendo mucho más — así un swipe largo nunca salta dos productos.
    - El objetivo siempre es currentIndex ± 1 sobre el valor más
      reciente; si un gesto nuevo decide su paso mientras el anterior aún
      se anima, gsap.to() redirige ese tween a su nuevo destino en vez de
      encolarlo o perderlo (comportamiento por defecto de GSAP al animar
      dos veces la misma propiedad del mismo target).
    - pointerup/pointercancel/lostpointercapture limpian el estado. Si el
      gesto llegó a consumirse, se bloquea el click posterior para que la
      tarjeta no navegue tras un swipe.
    - Un segundo dedo durante un gesto activo se ignora.
  */
  function initMobileShowcaseNav({ section, track, reels, lastIndex, syncCard, startIndex }) {
    const INTENT_THRESHOLD = 10;
    const TRIGGER_THRESHOLD = 45;

    let currentIndex = startIndex;
    let engaged = false;
    let activePointerId = null;
    let startX = 0;
    let startY = 0;
    let intent = 'pending';
    let consumed = false;
    let suppressNextClick = false;
    let pendingExit = null;
    let exitTween = null;
    let exitFrame = 0;
    let touchCount = 0;
    let disposed = false;
    let enteringTrack = false;

    function setIndex(index, animate) {
      currentIndex = Math.max(0, Math.min(lastIndex, index));
      section.dataset.showcaseIndex = String(currentIndex);
      syncCard(currentIndex);

      if (animate) {
        gsap.to(reels, { yPercent: -100 * currentIndex, duration: 0.45, ease: 'power2.out' });
      } else {
        gsap.set(reels, { yPercent: -100 * currentIndex });
      }
    }

    function release(direction, entering = false) {
      if (pendingExit || exitTween) return;
      pendingExit = { direction, entering };
      nankureShowcaseDebugLog((entering ? 'entrada pendiente ' : 'salida pendiente ') + direction);
    }

    function cancelExit() {
      cancelAnimationFrame(exitFrame);
      exitFrame = 0;
      pendingExit = null;
      if (exitTween) exitTween.kill();
      exitTween = null;
      enteringTrack = false;
    }

    function rearmOutsideViewport() {
      if (disposed || pendingExit || exitTween || !section.classList.contains('is-showcase-released')) return;
      const rect = section.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) {
        section.classList.remove('is-showcase-released');
      }
    }

    // Pointer capture can end before physical contact ends on iOS.
    // Wait for both streams, then leave the current event dispatch/frame.
    function completeGestureExit() {
      if (!pendingExit || touchCount || activePointerId !== null || disposed) return;
      cancelAnimationFrame(exitFrame);
      exitFrame = requestAnimationFrame(() => {
        exitFrame = requestAnimationFrame(() => {
          exitFrame = 0;
          if (!pendingExit || touchCount || activePointerId !== null || disposed) return;
          animateExit(pendingExit);
        });
      });
    }

    function animateExit({ direction, entering }) {
      enteringTrack = entering;
      engaged = entering;
      if (!entering) {
        section.classList.remove('is-sticky-active');
        section.classList.add('is-showcase-released');
      }
      const rect = track.getBoundingClientRect();
      const sectionHeight = section.getBoundingClientRect().height;
      const top = rect.top + window.scrollY;
      const stickyEnd = rect.bottom + window.scrollY - sectionHeight;
      const forward = direction === 'forward';
      const target = entering
        ? (forward ? top + 1 : stickyEnd - 1)
        : (forward ? rect.bottom + window.scrollY + 1 : top - window.innerHeight - 1);
      const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      const destination = Math.max(0, Math.min(maxScroll, target));

      if (entering) {
        gsap.killTweensOf(reels);
        setIndex(forward ? 0 : lastIndex, false);
      } else if (rect.top <= 0 && rect.bottom >= sectionHeight) {
        // Consume only the invisible part of the sticky track. The section
        // stays in exactly the same place; the visible exit is one viewport.
        window.scrollTo({ top: forward ? stickyEnd : top, left: window.scrollX, behavior: 'instant' });
      }
      const position = { y: window.scrollY };
      const distance = Math.abs(destination - position.y);

      nankureShowcaseDebugLog((entering ? 'entrada ' : 'salida ') + direction + ' destino=' + Math.round(destination));
      exitTween = gsap.to(position, {
        y: destination,
        duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 0.01 : Math.max(0.35, Math.min(0.85, distance / window.innerHeight * 0.8)),
        ease: 'power1.inOut',
        onUpdate: () => {
          if (!disposed && !touchCount) {
            window.scrollTo({ top: position.y, left: window.scrollX, behavior: 'instant' });
          }
        },
        onComplete: () => {
          exitTween = null;
          enteringTrack = false;
          if (entering) {
            engaged = true;
            section.classList.remove('is-showcase-released');
            section.classList.add('is-sticky-active');
          } else {
            rearmOutsideViewport();
          }
        }
      });
      pendingExit = null;
    }

    function step(direction) {
      const rect = track.getBoundingClientRect();
      const sectionHeight = section.getBoundingClientRect().height;
      // A swipe on a partially visible section is navigation into/out of it,
      // not a product step. Static touch-action also applies in this position.
      if (rect.top > 2) {
        release(direction > 0 ? 'forward' : 'back', direction > 0);
        return;
      }
      if (rect.bottom < sectionHeight - 2) {
        release(direction < 0 ? 'back' : 'forward', direction < 0);
        return;
      }
      const nextIndex = currentIndex + direction;

      nankureShowcaseDebugLog('step dir=' + direction + ' from=' + currentIndex + ' next=' + nextIndex);

      if (nextIndex < 0) { release('back'); return; }
      if (nextIndex > lastIndex) { release('forward'); return; }

      setIndex(nextIndex, true);
    }

    function endGesture() {
      activePointerId = null;
      intent = 'pending';

      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
      window.removeEventListener('pointercancel', onPointerCancel);
      window.removeEventListener('lostpointercapture', onPointerCancel);
    }

    function onPointerDown(event) {
      if (event.pointerType === 'mouse') return;
      if (activePointerId !== null) return;
      suppressNextClick = false;
      // An intentional product gesture supersedes a pending inertial landing.
      if (enteringTrack || (pendingExit && pendingExit.entering)) cancelExit();
      if (pendingExit || exitTween || section.classList.contains('is-showcase-released')) return;

      activePointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      intent = 'pending';
      consumed = false;
      /*
        Se resetea aquí (no solo tras un click) porque un swipe real no
        siempre genera un evento click después (el navegador solo lo
        dispara si el toque apenas se movió) — si se dejara en true hasta
        el próximo click, un tap genuino bastante después de un swipe
        antiguo podía quedar bloqueado sin motivo.
      */
      suppressNextClick = false;

      try { section.setPointerCapture(event.pointerId); } catch (error) {}

      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', onPointerCancel);
      window.addEventListener('lostpointercapture', onPointerCancel);
    }

    function onPointerMove(event) {
      if (event.pointerId !== activePointerId) return;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (intent === 'pending') {
        if (Math.abs(deltaX) < INTENT_THRESHOLD && Math.abs(deltaY) < INTENT_THRESHOLD) return;

        intent = Math.abs(deltaY) >= Math.abs(deltaX) ? 'vertical' : 'horizontal';
        nankureShowcaseDebugLog('intent=' + intent + ' dx=' + Math.round(deltaX) + ' dy=' + Math.round(deltaY));
      }

      if (intent !== 'vertical' || consumed) return;

      if (Math.abs(deltaY) >= TRIGGER_THRESHOLD) {
        consumed = true;
        suppressNextClick = true;
        /*
          Dedo hacia arriba (deltaY negativo) avanza al siguiente
          producto; dedo hacia abajo (deltaY positivo) retrocede.
        */
        step(deltaY < 0 ? 1 : -1);
      }
    }

    function onPointerUp(event) {
      if (event.pointerId !== activePointerId) return;
      nankureShowcaseDebugLog('pointerup consumed=' + consumed);
      endGesture();
      completeGestureExit();
    }

    function onPointerCancel(event) {
      if (activePointerId !== null && event.pointerId !== activePointerId) return;
      nankureShowcaseDebugLog('pointercancel/lostcapture');
      cancelExit();
      endGesture();
    }

    function onTouchStart(event) {
      touchCount = event.touches.length;
      // New input takes priority over a scheduled or running exit.
      if (exitTween || exitFrame) cancelExit();
      if (touchCount > 1) {
        cancelExit();
        endGesture();
      }
    }

    function onTouchEnd(event) {
      touchCount = event.touches.length;
      if (event.type === 'touchcancel') {
        cancelExit();
        endGesture();
        return;
      }
      completeGestureExit();
    }

    function onCardClick(event) {
      if (suppressNextClick) {
        suppressNextClick = false;
        event.preventDefault();
      }
    }

    section.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
    window.addEventListener('touchend', onTouchEnd, { passive: true, capture: true });
    window.addEventListener('touchcancel', onTouchEnd, { passive: true, capture: true });
    window.addEventListener('wheel', cancelExit, { passive: true });
    window.addEventListener('scroll', rearmOutsideViewport, { passive: true });

    const card = section.querySelector('[data-showcase-card]');
    if (card) card.addEventListener('click', onCardClick);

    ScrollTrigger.create({
      id: PRODUCT_TRIGGER_ID,
      trigger: track,
      start: 'top top',
      end: 'bottom bottom',

      /*
        D-20: ScrollTrigger.refresh() (llamado tras cargar, en resize, o
        por otras secciones con pin de la misma página) puede reevaluar
        y volver a disparar onEnter/onEnterBack aunque lógicamente ya
        estemos dentro desde antes — si eso resetea el índice a medio
        gesto, se pierde lo que el usuario ya había navegado. `engaged`
        es un flag propio (no el de GSAP) que distingue una entrada
        GENUINA (veníamos de fuera) de una reevaluación mientras ya
        estábamos dentro: solo se resetea el índice en el primer caso.
      */
      onEnter: () => {
        if (pendingExit || exitTween || ScrollTrigger.isRefreshing) return;
        if (engaged) { nankureShowcaseDebugLog('onEnter ignorado (ya enganchado)'); return; }
        engaged = true;
        section.classList.remove('is-showcase-released');
        section.classList.add('is-sticky-active');
        setIndex(0, false);
        nankureShowcaseDebugLog('onEnter -> index 0');
        // A gesture that began outside can keep scrolling through the track.
        // Land at this boundary once physical contact has ended.
        release('forward', true);
        completeGestureExit();
      },

      onEnterBack: () => {
        if (pendingExit || exitTween || ScrollTrigger.isRefreshing) return;
        if (engaged) { nankureShowcaseDebugLog('onEnterBack ignorado (ya enganchado)'); return; }
        engaged = true;
        section.classList.remove('is-showcase-released');
        section.classList.add('is-sticky-active');
        setIndex(lastIndex, false);
        nankureShowcaseDebugLog('onEnterBack -> index ' + lastIndex);
        release('back', true);
        completeGestureExit();
      },

      onLeave: () => {
        if (pendingExit || exitTween || ScrollTrigger.isRefreshing) return;
        engaged = false;
        section.classList.remove('is-sticky-active');
        nankureShowcaseDebugLog('onLeave');
      },

      onLeaveBack: () => {
        if (pendingExit || exitTween || ScrollTrigger.isRefreshing) return;
        engaged = false;
        section.classList.remove('is-sticky-active');
        nankureShowcaseDebugLog('onLeaveBack');
      }
    });

    return function cleanupMobileShowcaseNav() {
      disposed = true;
      cancelExit();
      section.removeEventListener('pointerdown', onPointerDown);
      window.removeEventListener('touchstart', onTouchStart, true);
      window.removeEventListener('touchend', onTouchEnd, true);
      window.removeEventListener('touchcancel', onTouchEnd, true);
      window.removeEventListener('wheel', cancelExit);
      window.removeEventListener('scroll', rearmOutsideViewport);
      if (card) card.removeEventListener('click', onCardClick);
      endGesture();
      section.classList.remove('is-showcase-released');
    };
  }

  function createTrack(section, trackClass, steps) {
    if (!section) return null;

    const currentParent = section.parentElement;

    if (currentParent && currentParent.classList.contains(trackClass)) {
      currentParent.style.setProperty('--nankure-track-steps', String(steps));
      return currentParent;
    }

    const track = document.createElement('div');

    track.className = trackClass;
    track.style.setProperty('--nankure-track-steps', String(steps));

    section.parentNode.insertBefore(track, section);
    track.appendChild(section);

    return track;
  }

  /*
    D-8: lee del DOM el índice que ya estaba activo antes de reconstruir
    (initActivesClickOnly se llama de nuevo en cada resize). Sin esto,
    cualquier resize —incluida una rotación de móvil— devolvía Actives a
    su primer estado.
  */
  function getIndexedActiveIndex(section, attrName, length) {
    const activeEl = section.querySelector(`[${attrName}].is-active`);
    if (!activeEl) return 0;

    const value = Number(activeEl.getAttribute(attrName));
    if (!Number.isFinite(value)) return 0;

    return Math.max(0, Math.min(length - 1, value));
  }

  function initProducts() {
    if (!hasGSAP()) return;

    const section = document.querySelector('[data-nankure-showcase]');
    if (!section) return;

    const products = parseJSON(section.querySelector('[data-showcase-products-json]'));
    if (!products.length) return;

    killTrigger(PRODUCT_TRIGGER_ID);
    if (mobileShowcaseCleanup) {
      mobileShowcaseCleanup();
      mobileShowcaseCleanup = null;
    }

    const card = section.querySelector('[data-showcase-card]');
    const reels = Array.from(section.querySelectorAll('[data-showcase-reel]'));

    if (!card || !reels.length) return;

    /*
      Al reconstruir (resize / shopify:section:load) hay que matar también
      el tween anterior sobre los reels; killTrigger sólo mata el
      ScrollTrigger, no la animación que llevaba asociada.
    */
    gsap.killTweensOf(reels);

    const lastIndex = products.length - 1;

    /*
      D-13: cada producto ocupa 0.85 alturas de viewport, más 0.6 de
      colchón final para que el último no se expulse en seco.

      En móvil el scroll es 1:1 con el dedo (a diferencia de la rueda del
      ratón, que cubre mucha más distancia por gesto), así que la misma
      distancia se siente muy pesada de arrastrar. Se reduce solo en
      móvil para que avanzar un producto no exija casi una pantalla
      entera de swipe; desktop mantiene exactamente los mismos valores.
    */
    const isMobileViewport = window.innerWidth <= 767;
    const perProductVh = isMobileViewport ? 0.45 : 0.85;
    const tailVh = isMobileViewport ? 0.35 : 0.6;
    const steps = Math.max(1.6, products.length * perProductVh + tailVh);
    const track = createTrack(section, 'nankure-home-products-track', steps);
    if (!track) return;

    section.classList.add('is-ready');

    let currentIndex = -1;

    function syncCard(index) {
      if (index === currentIndex) return;

      currentIndex = index;

      const product = products[index];

      card.href = product.url || '#';
      card.setAttribute('aria-label', product.title ? 'Ver ' + product.title : 'Ver producto');
    }

    /*
      D-8b: en móvil el índice inicial es el persistido en el DOM (para
      sobrevivir a una reconstrucción real a mitad de interacción, ver
      D-18); en desktop siempre 0, como hasta ahora.
    */
    const startIndex = isMobileViewport ? getPersistedShowcaseIndex(section, lastIndex) : 0;
    gsap.set(reels, { yPercent: -100 * startIndex });
    syncCard(startIndex);

    if (lastIndex < 1) return;

    if (isMobileViewport) {
      mobileShowcaseCleanup = initMobileShowcaseNav({ section, track, reels, lastIndex, syncCard, startIndex });
      return;
    }

    /*
      D-12: todos los reels comparten un único tween lineal gobernado por
      el scroll. Como la posición es continua (no un índice discreto que
      dispara animaciones sueltas), es imposible que el scroll se salte un
      producto: pasar del 1 al 3 obliga a atravesar el 2. El snap
      direccional remata cada gesto sobre el producto siguiente. Esto
      solo se usa en desktop: con rueda de ratón cada "tick" ya es un
      salto claro, así que no compite con ninguna inercia nativa.
    */
    const reelTween = gsap.to(reels, {
      yPercent: -100 * lastIndex,
      ease: 'none'
    });

    ScrollTrigger.create({
      id: PRODUCT_TRIGGER_ID,
      trigger: track,
      start: 'top top',
      end: 'bottom bottom',
      animation: reelTween,

      /*
        D-14: scrub bajo. Con un valor alto (1s) los reels perseguían al
        scroll con retardo y la sección se quedaba parada a medio camino
        entre dos productos; 0.3 mantiene el movimiento suave pero pegado
        al gesto.
      */
      scrub: 0.3,
      invalidateOnRefresh: true,

      snap: {
        snapTo: 1 / lastIndex,
        duration: { min: 0.25, max: 0.5 },
        delay: 0.02,
        ease: 'power2.out',
        inertia: false
      },

      onEnter: () => {
        section.classList.add('is-sticky-active');
      },

      onEnterBack: () => {
        section.classList.add('is-sticky-active');
      },

      onLeave: () => {
        section.classList.remove('is-sticky-active');
      },

      onLeaveBack: () => {
        section.classList.remove('is-sticky-active');
      },

      onUpdate: (self) => {
        syncCard(Math.max(0, Math.min(lastIndex, Math.round(self.progress * lastIndex))));
      }
    });
  }

  function initActivesClickOnly() {
    const section = document.querySelector('[data-nankure-actives]');
    if (!section) return;

    const items = parseJSON(section.querySelector('[data-actives-json]'));
    if (!items.length) return;

    const tabsContainer = section.querySelector('[data-actives-tabs]');
    const panelEl = section.querySelector('.nankure-home-actives__content');
    const tabs = Array.from(section.querySelectorAll('[data-active-index]'));
    const leftEl = section.querySelector('[data-active-left]');
    const titleEl = section.querySelector('[data-active-title]');
    const rightEl = section.querySelector('[data-active-right]');
    const imageEl = section.querySelector('[data-active-image]');

    if (!tabs.length || !leftEl || !titleEl || !rightEl || !imageEl) return;

    const startIndex = getIndexedActiveIndex(section, 'data-active-index', items.length);

    const imageWrap = imageEl.parentElement;
    const textFields = [
      { el: titleEl, mask: titleEl.parentElement },
      { el: leftEl, mask: leftEl.parentElement },
      { el: rightEl, mask: rightEl.parentElement }
    ];

    let currentIndex = -1;
    let activeTimeline = null;

    const DURATION = 1.05;
    const EASE = 'power3.out';

    items.forEach((item) => {
      if (!item.image) return;

      const img = new Image();
      img.src = item.image;
    });

    /*
      D-15: el texto saliente sube y se oculta tras el borde de su
      contenedor mientras el entrante llega desde abajo. Como en el DOM
      sólo existe un elemento por campo (el texto se reemplaza), se clona
      el saliente para poder animar los dos a la vez.
    */
    function pushText(field, newValue) {
      const clone = field.el.cloneNode(true);

      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-active-left');
      clone.removeAttribute('data-active-title');
      clone.removeAttribute('data-active-right');

      field.mask.appendChild(clone);

      gsap.set(clone, { position: 'absolute', left: 0, top: 0, width: '100%', yPercent: 0 });
      gsap.to(clone, {
        yPercent: -100,
        duration: DURATION,
        ease: EASE,
        onComplete: () => clone.remove()
      });

      field.el.textContent = newValue;
      gsap.fromTo(field.el, { yPercent: 100 }, { yPercent: 0, duration: DURATION, ease: EASE });
    }

    function setActive(index, options) {
      index = Math.max(0, Math.min(items.length - 1, index));

      if (index === currentIndex) return;

      const isInitial = !!(options && options.initial);
      const item = items[index];

      currentIndex = index;

      tabs.forEach((tab) => {
        const isActive = Number(tab.dataset.activeIndex) === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      if (panelEl) {
        panelEl.setAttribute('aria-labelledby', 'nankure-actives-tab-' + index);
      }

      if (activeTimeline) activeTimeline.kill();

      /*
        Si una transición previa se interrumpe, su onComplete no llega a
        limpiar el clon; lo barremos antes de crear los nuevos.
      */
      textFields.forEach((field) => {
        field.mask.querySelectorAll('[aria-hidden="true"]').forEach((c) => c.remove());
      });
      imageWrap.querySelectorAll('.nankure-home-actives__image--outgoing').forEach((c) => c.remove());

      if (isInitial || !hasGSAP()) {
        titleEl.textContent = item.title || '';
        leftEl.textContent = item.left || '';
        rightEl.textContent = item.right || '';

        if (item.image) imageEl.src = item.image;
        imageEl.alt = item.alt || item.title || '';

        return;
      }

      /*
        La planta saliente se amplía y se desvanece en el sitio; la
        entrante sube desde abajo apareciendo (referencia: home.mov).
      */
      const outgoing = imageEl.cloneNode(true);
      outgoing.classList.add('nankure-home-actives__image--outgoing');
      outgoing.removeAttribute('data-active-image');
      outgoing.setAttribute('aria-hidden', 'true');
      imageWrap.appendChild(outgoing);

      const tl = gsap.timeline();
      activeTimeline = tl;

      tl.to(outgoing, {
        scale: 1.35,
        opacity: 0,
        duration: DURATION + 0.25,
        ease: 'power2.out',
        onComplete: () => outgoing.remove()
      }, 0);

      if (item.image) imageEl.src = item.image;
      imageEl.alt = item.alt || item.title || '';

      tl.fromTo(imageEl,
        { yPercent: 30, opacity: 0, scale: 1 },
        { yPercent: 0, opacity: 1, scale: 1, duration: DURATION + 0.25, ease: 'power2.out' },
      0);

      pushText(textFields[0], item.title || '');
      pushText(textFields[1], item.left || '');
      pushText(textFields[2], item.right || '');
    }

    section.classList.add('is-ready');
    setActive(startIndex, { initial: true });

    tabs.forEach((tab) => {
      if (tab.dataset.nankureClickReady === 'true') return;

      tab.dataset.nankureClickReady = 'true';

      tab.addEventListener('click', () => {
        const index = Number(tab.dataset.activeIndex);
        setActive(index);
      });
    });

    if (tabsContainer && tabsContainer.dataset.nankureKeyboardReady !== 'true') {
      tabsContainer.dataset.nankureKeyboardReady = 'true';

      tabsContainer.addEventListener('keydown', (event) => {
        let newIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          newIndex = (currentIndex + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          newIndex = 0;
        } else if (event.key === 'End') {
          newIndex = tabs.length - 1;
        }

        if (newIndex === null) return;

        event.preventDefault();
        setActive(newIndex);

        const newTab = tabs[newIndex];
        if (newTab) newTab.focus();
      });
    }
  }

  function initNankureHomeSections() {
    if (!hasGSAP()) return;

    gsap.registerPlugin(ScrollTrigger);

    setRealViewportHeight();

    initProducts();
    initActivesClickOnly();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        ScrollTrigger.refresh();
      });
    });

    window.setTimeout(() => {
      ScrollTrigger.refresh();
    }, 700);
  }

  function bootNankureHomeSections() {
    window.clearTimeout(window.__nankureHomeSectionsBoot);

    window.__nankureHomeSectionsBoot = window.setTimeout(() => {
      initNankureHomeSections();
    }, 250);
  }

  document.addEventListener('DOMContentLoaded', bootNankureHomeSections);
  window.addEventListener('load', bootNankureHomeSections);
  document.addEventListener('shopify:section:load', bootNankureHomeSections);

  /*
    D-18: este 'resize' reconstruye TODO (ScrollTrigger, tweens, y ahora
    también los listeners de gesto del Showcase en móvil) desde cero. En
    móvil, la barra de Safari también dispara 'resize' al mostrarse/
    ocultarse mientras el usuario hace scroll — justo cuando más probable
    es que esté interactuando con el Showcase — así que el componente se
    destruía y reconstruía a mitad de gesto, perdiendo el índice y
    cualquier estado en curso. Se reconstruye solo si cambia el ANCHO
    (o la altura sube o baja mucho, señal de rotación real), nunca por un
    cambio de alto pequeño como el de la barra — igual que ya se filtra
    para --nankure-real-vh más abajo.
  */
  let lastWindowResizeWidth = window.innerWidth;
  let lastWindowResizeHeight = window.innerHeight;

  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;

    const widthChanged = currentWidth !== lastWindowResizeWidth;
    const heightChanged = Math.abs(currentHeight - lastWindowResizeHeight) > 150;

    lastWindowResizeWidth = currentWidth;
    lastWindowResizeHeight = currentHeight;

    if (!widthChanged && !heightChanged) return;

    window.clearTimeout(window.__nankureHomeSectionsResize);

    window.__nankureHomeSectionsResize = window.setTimeout(() => {
      initNankureHomeSections();
    }, 350);
  });

  if (window.visualViewport) {
    const VIEWPORT_HEIGHT_TOOLBAR_THRESHOLD = 120;

    let lastViewportWidth = window.visualViewport.width;
    let lastViewportHeight = window.visualViewport.height;

    window.visualViewport.addEventListener('resize', () => {
      const currentWidth = window.visualViewport.width;
      const currentHeight = window.visualViewport.height;

      const widthChanged = Math.abs(currentWidth - lastViewportWidth) > 1;
      const heightDelta = Math.abs(currentHeight - lastViewportHeight);

      lastViewportWidth = currentWidth;
      lastViewportHeight = currentHeight;

      /*
        P-3: la barra de Safari se colapsa/expande durante el scroll y
        dispara este evento con el mismo ancho y un delta de alto pequeño.
        Recalcular a mitad de gesto producía un salto de posición, así
        que para este caso esperamos un silencio más largo (que el gesto
        y la animación de la barra hayan terminado del todo) en vez de
        ignorarlo para siempre: ignorarlo por completo dejaba
        --nankure-real-vh fijado en la altura que tenía la barra en el
        momento de cargar la página, así que si la barra cambiaba de
        estado más tarde la sección dejaba de llenar el 100% de la
        altura real.
      */
      const isToolbarChange = !widthChanged && heightDelta < VIEWPORT_HEIGHT_TOOLBAR_THRESHOLD;
      const settleDelay = isToolbarChange ? 500 : 150;

      window.clearTimeout(window.__nankureViewportRefresh);

      window.__nankureViewportRefresh = window.setTimeout(() => {
        setRealViewportHeight();

        if (typeof ScrollTrigger !== 'undefined') {
          ScrollTrigger.refresh();
        }
      }, settleDelay);
    });
  }
})();
